import { render, staticRenderFns } from "./jobOpportunities.vue?vue&type=template&id=225e3862&scoped=true&"
import script from "./jobOpportunities.vue?vue&type=script&lang=js&"
export * from "./jobOpportunities.vue?vue&type=script&lang=js&"
import style0 from "./jobOpportunities.vue?vue&type=style&index=0&id=225e3862&prod&lang=scss&"
import style1 from "./jobOpportunities.vue?vue&type=style&index=1&id=225e3862&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225e3862",
  null
  
)

export default component.exports